import { KeyboardContext } from 'components/Layout/ControlBar/components/Keyboard/Keyboard';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import './LetterBlock.module.scss';

export type SoundType =
    | 'short-sound'
    | 'long-sound'
    | 'two-symbol-sound'
    | 'special-sound'
    | 'consonant'
    | 'stupid-sound'
    | 'special-character-sound'
    | '';

export type LetterBlockProps = {
    soundType: SoundType;
    letter?: string;
    grayedOut?: boolean;
};

export default function LetterBlock({
    soundType,
    letter = '',
    grayedOut,
}: LetterBlockProps) {
    const { setKeyboardInput } = useContext(GlobalContext);
    const { isKeyboard } = useContext(KeyboardContext);
    const [shouldHover, setShouldHover] = useState(true);
    const ref = useRef<HTMLDivElement>(null);

    function handleClick() {
        if (!isKeyboard) return;

        setKeyboardInput((prev) => [...prev, letter]);
    }

    useEffect(
        () =>
            ref?.current?.parentElement?.className.includes(
                'MultiKeyboardBlocks'
            )
                ? setShouldHover(false)
                : setShouldHover(true),
        []
    );

    return (
        <motion.div
            ref={ref}
            whileHover={shouldHover ? { scale: 1.03 } : {}}
            whileTap={shouldHover ? { scale: 0.97 } : {}}
            styleName={`wrapper ${grayedOut ? 'grayedOut' : ''} ${soundType} 
            `}
            style={{
                cursor: isKeyboard ? 'pointer' : 'default',
                width: isKeyboard ? 34 : 40,
                height: isKeyboard ? 32 : 38,
            }}
            onClick={handleClick}
        >
            {letter && (
                <h3 style={{ fontSize: isKeyboard ? 20 : 22 }}>{letter}</h3>
            )}
        </motion.div>
    );
}
